import {Link} from 'react-router-dom'
import BottomNav from './BottomNav'

const Nav = () => {
  return (
    <nav>
      <BottomNav />
    </nav>
  )
}
export default Nav